/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_540d8251',
  resizeIsShort: 'resizeIsShort_540d8251',
  buttonGroup: 'buttonGroup_540d8251',
  settingsGroup: 'settingsGroup_540d8251',
  itemCountDropdown: 'itemCountDropdown_540d8251',
};

export = styles;

loadStyles([{"rawString":".root_540d8251{display:block}.resizeIsShort_540d8251{width:400px}.buttonGroup_540d8251{margin-bottom:40px}.buttonGroup_540d8251 button{margin-right:20px}.settingsGroup_540d8251{padding-top:20px}.itemCountDropdown_540d8251{width:180px}"}]);
/* tslint:enable */